import React, { useState } from 'react';
import ShellV1 from '@/v1/components/application/Shell';
import ShellV2 from '@/v2/components/application/Shell';
import query from '@/v2/state/query';

function App() {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState();

    const setter = (body) => {
        setData(body);
        setLoading(false);
    };

    query(window.HELIOS.selectors.application, setter);

    // TODO: Decide and test how are we gonna show up this
    if (isLoading) {
        return <div className="App" />;
    }

    const { isUpdatedVersion } = data;
    if (!!isUpdatedVersion === true) {
        return <ShellV2 />;
    }
    return (
        <section className="VirtualCar--v1">
            <ShellV1 />
        </section>
    );
}

export default App;
